import { render, staticRenderFns } from "./spzq.vue?vue&type=template&id=5b18f433"
import script from "./spzq.vue?vue&type=script&lang=js"
export * from "./spzq.vue?vue&type=script&lang=js"
import style0 from "./spzq.vue?vue&type=style&index=0&id=5b18f433&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports